import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../textBoxWithTooltip';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    backgroundColor: primary.blue8,
    border: `1px solid ${primary.blue5}`,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    padding: spacing(0, 2),
    height: 28,
    maxWidth: '100%',
    minWidth: 0,
    width: 'fit-content',
  },
  title: {
    lineHeight: '20px',
    justifySelf: 'start',
    maxWidth: '100%',
  },
}));

const QuestionnaireChip = ({ customClass = null, titleClass = undefined, name = '' }) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, customClass)}>
      <TextBoxWithTooltip
        variant="subtitle2"
        className={classNames(classes.title, titleClass)}
        text={name}
      />
    </div>
  );
};

QuestionnaireChip.propTypes = {
  name: PropTypes.string,
  customClass: PropTypes.string,
  titleClass: PropTypes.string,
};

export default QuestionnaireChip;
